var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApiCommandline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 519.92 413.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#ccc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 519.92,
    height: 413.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M412.48,51.87h-305a63.11,63.11,0,0,0-63,63V298.57a63.11,63.11,0,0,0,63,63h305a63.11,63.11,0,0,0,63-63V114.91A63.11,63.11,0,0,0,412.48,51.87Zm42,246.7a42,42,0,0,1-42,41.95h-305a42,42,0,0,1-41.95-41.95V114.91a42,42,0,0,1,42-41.95h305a42,42,0,0,1,42,42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M355.72,160.48a10.54,10.54,0,1,0-14.91,14.91l34.3,34.3L340.81,244a10.54,10.54,0,1,0,14.91,14.91l41.76-41.76a10.54,10.54,0,0,0,0-14.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M180.36,160.48a10.54,10.54,0,0,0-14.91,0L123.7,202.24a10.54,10.54,0,0,0,0,14.91l41.75,41.76A10.54,10.54,0,0,0,180.36,244l-34.3-34.31,34.3-34.3A10.54,10.54,0,0,0,180.36,160.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.87,158.3A10.55,10.55,0,0,0,269,163.64l-37.24,83.52A10.54,10.54,0,1,0,251,255.75l37.24-83.52A10.55,10.55,0,0,0,282.87,158.3Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiCommandline);
export default __webpack_public_path__ + "static/media/api-commandline.ea1876afd760d3e784af41d6718bdeb4.svg";
export { ForwardRef as ReactComponent };